import { useContext } from "react";
import { store } from "../store.js";
import useGetCurrentsTools from "./useGetCurrentsTools.js";
import useGetDataFromPathId from "./useGetDataFromPathId.js";
import useBuildDataAndTree from "./useBuildDataAndTree";
import useSetDependencies from "./useSetDependencies";

const useUpdateOccurenceValue = () => {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const getCurrentsTools = useGetCurrentsTools();
  const getDataFromPathId = useGetDataFromPathId();
  const buildDataAndTree = useBuildDataAndTree();
  const setDependencies = useSetDependencies();
  
  var updateApiData = false
  
  const changeValue = (newValue, menuItem, type, isProperty, event
    , currentIds, options = undefined, formData=undefined
    , settings = { maskData : "", groupSeparator : "", changeMode : undefined}) => {
      
      
    var updatedToolData = formData?formData : JSON.parse(JSON.stringify(globalState.state.formData));
    //var parameters = {newValue:newValue, menuItem:menuItem,type:type,isProperty: isProperty}
    var dependencies = [];
    
    updateOccurenceValue(updatedToolData, newValue, menuItem, type, isProperty, event, 
      currentIds, options, dependencies, settings, updatedToolData);

    var currentsTools = [];
    
    setDependenciesValues(updatedToolData, dependencies, event) 
    
    if(!formData) {
      getCurrentsTools(updatedToolData, currentsTools, currentIds.actualToolIds, {event:event, type:"byId"});
      updatedToolData.currentTool = currentsTools;
      if (settings.changeMode != undefined)
      updatedToolData.isEditTool = settings.changeMode;
      if (updateApiData) buildDataAndTree(updatedToolData, true)
      
      if (updatedToolData.isExecutionMode)  buildDataAndTree(updatedToolData, false)
      updatedToolData.errors = updatedToolData.errors.filter(error => !currentIds.actualToolIds.includes(error.id))
      
      dispatch({
        type: "UPDATE_FORM",
        payload: updatedToolData,
      });
    }
  };

  const setDependenciesValues = (updatedToolData, dependencies, event) => {
    
    dependencies.filter(dependency => {
        if (dependency.condition) {
          
          if (canUpdateValue(updatedToolData, dependency.condition.details)){
          changeValue(dependency.condition.value, dependency.menu, dependency.type, dependency.isProperty, event
            , {actualToolGlobalIds:[dependency.globalId], actualToolIds:[dependency.id]}//, [dependency.id]
            , undefined, updatedToolData, 
            { maskData : dependency.properties.masks && dependency.properties.masks.value, 
              prefix : dependency.properties.prefix && dependency.properties.prefix.value,
              suffix : dependency.properties.suffix && dependency.properties.suffix.value,
              groupSeparator : dependency.properties.groupSeparator && dependency.properties.groupSeparator.value,
              groupSize : dependency.properties.groupSize && parseInt(dependency.properties.groupSize.value)});
          }
        }
        
        if (dependency.relationShipProperty) {
          changeValue(dependency.relationShipProperty.value, dependency.menu, dependency.type, dependency.isProperty, event
            , {actualToolGlobalIds:[dependency.globalId], actualToolIds:[dependency.id]} //, [dependency.id]
            , undefined, updatedToolData, 
            { maskData : dependency.properties.masks && dependency.properties.masks.value, 
              prefix : dependency.properties.prefix && dependency.properties.prefix.value,
              suffix : dependency.properties.suffix && dependency.properties.suffix.value,
              groupSeparator : dependency.properties.groupSeparator && dependency.properties.groupSeparator.value,
              groupSize : dependency.properties.groupSize && parseInt(dependency.properties.groupSize.value)});
      }
    })
  };

  const canUpdateValue = (updatedToolData, details, i = 0, response = true) => {
    
    if (details.length == i)
      return response
    if (!evaluationOperation(updatedToolData, details[i]))
      return false
    else
      return canUpdateValue(updatedToolData, details, i + 1, response)
    
  };

  const evaluationOperation = (updatedToolData, detail) => {
    const firstOperand = getDataFromPathId(updatedToolData, detail.firstOperand.value) + "" //getCurrentValue
    const operator = detail.operator.value
    const secondOperand = getDataFromPathId(updatedToolData, detail.secondOperand.value) + "" //getCurrentValue
    
    return isConditionChecked(firstOperand.trim().toLowerCase(), operator, secondOperand.trim().toLowerCase())
  };

  const isReferenceValue = (value) => {
    return Array.isArray(value)
  };

  /*const getCurrentValue = (updatedToolData, value) => {
    if (isReferenceValue(value)) {
      return getValue(updatedToolData, value.slice(-1))
    }
    else
      return value
  };

  const getValue = (updatedToolData, id) => {
    var currentTools = []
    getCurrentsTools( updatedToolData, currentTools, id)
    return currentTools[0]["properties"]["text"].value
  }*/

  const isConditionChecked = (firstOperand, operator, secondOperand) => {
    switch (operator) {
      case "=":
        return firstOperand == secondOperand
      case "<>":
        return firstOperand != secondOperand
      case ">":
        return firstOperand > secondOperand
      case ">=":
        return firstOperand >= secondOperand
      case "<":
        return firstOperand < secondOperand
      case "<=":
        return firstOperand <= secondOperand
    }
  };
  
  const getPlaceHolderValue = (char, maskedValues) => {
  
    if (!maskedValues.includes(char))
      char = "_"
    return char
  };
  
  const getMaskValue = (maskData, newValue, oldMaskValue) => {
    var shift = 0
    if (maskData != "") {
      var maskedValues = maskData.split("")
      if (newValue != "") {
       
        var newValues = newValue.split("")
        if (maskData.length > newValue.length) {
          if (oldMaskValue) {
            var oldMaskValues = oldMaskValue.split("")
            oldMaskValues.map((char, index) => {
              if (index == newValues.length) {
                
                newValues = [...newValue.slice(0, index), getPlaceHolderValue(char, maskedValues)]
              }
              if (char != newValues[index]) {
                
                newValues = [...newValue.slice(0, index), getPlaceHolderValue(char, maskedValues), ...newValue.slice(index, newValue.length)]
              }
            })
            newValue = newValues.join("")
          }else newValue = undefined

        } else {
          
          maskedValues.map((mask, index) => {
            if (mask == "_") {
              if (!maskData.split("").includes(newValues[index])) { 
                
                maskedValues[index] = newValues[index]
                
                  if (newValues[index+1] == "_") 
                    newValues = [...newValues.slice(0, index+1), ...newValues.slice(index + 2, newValues.length)]
              }
            } else {
              if (!maskData.split("").includes(newValues[index])) { 
                shift = shift + 1
                newValues[index+1] = newValues[index]
                newValues[index] = mask
              }
            }
          })
          newValue = maskedValues.join("")
        }
        
      }
    } else newValue = undefined
    return {maskValue:newValue, shift:shift}
  };
 
  const extractValueFromMask = (settings, newValue, oldValue) => {
    
    if (settings.maskData && settings.maskData != "") {
      if (newValue != "") {
        if (newValue.length > settings.maskData.length) {
          newValue = oldValue
        } else {
          var maskValues = settings.maskData.split("")
          var newValues = newValue.split("")
          newValues = newValues.filter(char => !maskValues.includes(char))  
          newValue = newValues.join("")
        } 
      }
    }   
    
    if (settings.groupSeparator && settings.groupSeparator != "")
      newValue = newValue.replaceAll(settings.groupSeparator, "")
    
    return newValue
  };

  /*
  const isConditionActif = (options) => {
    return options.option.filter(item => item.value == globalState.state.formData.actions.option.condition).length>0 
  }*/

  const getItemConditions = (item) => {
    var conditions = []
    Object.entries(item.properties).map(([menu, value], index) => {
      let currentCondition = item.properties[menu].conditions
     if (globalState.state.formData.actions.option.condition == item.properties[menu].option
      && currentCondition) conditions.push({...currentCondition, isProperty:true, type:"properties", menu:menu})
    })
    Object.entries(item.styles).map(([menu, value], index) => {
      let currentCondition = item.styles[menu].conditions
     if ( globalState.state.formData.actions.option.condition == item.styles[menu].option
       && currentCondition) conditions.push({...currentCondition, isProperty:false, type:"styles", menu:menu})
    })
     
    return conditions
  }

  const getItemMapping = (item) => {
    var mappings = []
    if (item.properties.data && globalState.state.formData.actions.option.mapping == item.properties.data.option)
      mappings.push({...item.properties.data.mapping, isProperty:true, type:"properties", menu:"data"})
       
    return mappings
  }

  const isAlreadyAdded = (id, dependencies, condition) => {
    return dependencies.filter(item => id == item.id && item.type == condition.type && item.menu == condition.menu ).length>0 
  }


  const updateOccurenceValue = (containers, newValue, menuItem, type, isProperty, event, currentIds, options, dependencies, settings, form) => {
    
    type = type.toLowerCase()
    if (!containers.metaData) return;
    containers.metaData.map(item => {
      
      const firtsComponentId = currentIds.actualToolGlobalIds[0] //dependencies manage only first currentool
      setDependencies(firtsComponentId, item,  dependencies)
      
      /*
      if (firtsComponentId != item.id) { //|| (type != "properties" && menuItem != "text" )
        
        const menuText = item["properties"]["text"]
        if (!menuText.option || menuText.option == globalState.state.formData.actions.option.text) {
          
          let textItem = item.properties.text
          if(textItem.relationShipValue && textItem.relationShipValue.includes(firtsComponentId)) {
            
            dependencies.push({globalId:item.globalId,id:item.id, isProperty:true, type:"properties", menu:"text"
            , relationShipProperty : { value : textItem.relationShipValue}, properties: item.properties})
          }
        }
        
          getItemConditions(item).filter(condition => {
            condition.values.values.map(data =>  
              data.details.map(detail => {
                if (!isAlreadyAdded(data.id, dependencies, condition)) { //if (!alreadyAddedsConditions.includes(data.id)) {
                  let isFirstOperandRelationData = isReferenceValue(detail.firstOperand.value) && detail.firstOperand.value.includes(firtsComponentId)
                  let isSecondOperandRelationData = isReferenceValue(detail.secondOperand.value) && detail.secondOperand.value.includes(firtsComponentId)
                  if (isFirstOperandRelationData || isSecondOperandRelationData){
                    
                    dependencies.push({globalId:item.globalId, id:item.id, isProperty:condition.isProperty, type:condition.type, menu:condition.menu
                      , condition : data, properties: item.properties})
                  }
                }
                //alreadyAddedsConditions.push(data.id)
              })
            )
          })
        //}
        
      }
      */
      if (currentIds.actualToolIds.includes(item.id)) {
        var currentMenu = item[type.toLowerCase()][menuItem]
        const isDefaultEvent = event == globalState.state.formData.actions.event.type.onLoad
        //if (isProperty) {
          if (currentMenu.selectedValues) {
            //manage list choice selection
            if (currentMenu.selectedValues.map(item=> item.id).includes(newValue.id))
              currentMenu.selectedValues = currentMenu.selectedValues.filter(item => item.id != newValue.id )
            else
              currentMenu.selectedValues.push(newValue)

            if(currentMenu.selectedValues.length == 1){           
              currentMenu.value = currentMenu.selectedValues[0].type
            }
            else if(currentMenu.selectedValues.length > 1)
              currentMenu.value = "Many..."
            else  currentMenu.value = ""
            
          } 
          else {
            if (currentMenu.relationShipValue) {
              currentMenu["prevRelationShipValues"] = [...currentMenu.relationShipValue]
              if (isReferenceValue(newValue)) 
                currentMenu["relationShipValue"] = newValue
              else
                currentMenu["relationShipValue"] = undefined           
            } else {           
              if (isReferenceValue(newValue)) currentMenu["relationShipValue"] = newValue
            } 
              
            if (currentMenu.relationShipValue) newValue = currentMenu["relationShipValue"]  
            
            
            newValue = getDataFromPathId(form, newValue)  //getCurrentValue
            
            if (settings.maskData && settings.maskData != "") {
              const maskInfo = getMaskValue(settings.maskData, newValue, currentMenu.maskValue)
              currentMenu["maskValue"] = maskInfo.maskValue
              currentMenu["caretPosition"] = settings.caretPosition + maskInfo.shift 
              newValue = maskInfo.maskValue
            }    
            else if (settings.groupSeparator && settings.groupSeparator != "") {
              currentMenu["maskValue"] = undefined            
              const newValueLength = newValue.replaceAll(settings.groupSeparator,"").replaceAll(settings.prefix,"").replaceAll(settings.suffix,"").length            
              const shift = newValueLength < settings.groupSize ? 0 : newValueLength % settings.groupSize
              currentMenu["caretPosition"] = settings.caretPosition + (shift == 1 ? 1 : 0)
            } else {
              currentMenu["maskValue"] = undefined
              currentMenu["caretPosition"] = undefined
            }
            
            if (isDefaultEvent)  //defaul event 
              currentMenu.value = extractValueFromMask(settings, newValue, currentMenu.value)
            else //for property actions only
              setValue(item, type, menuItem,newValue, event)
          }
        //}
    //    else {    
    //      setStyle(item, type, menuItem,newValue, event)
          //item[type.toLowerCase()][menuItem] = newValue
    //    }
        
        if (options) { 
          let isValidOption = false
          if (options.conditions.values) {
            isValidOption = true
            item[type][menuItem].conditions ={values:options.conditions}
            //setConditions(item, type, menuItem, options, isProperty, event)     
          }
          if (options.api.values) {
            updateApiData = true
            isValidOption = true
            item[type][menuItem].api = {values:options.api}
            //setApi(item, type, menuItem, options, isProperty, event)      
          }
          if (options.data && (options.data.list.values || options.data.mapping.values || options.data.tree.values)) {
            isValidOption = true
            item[type][menuItem].value = options.data //options.data
            //setPrpopertyValue(item, type, menuItem, options)    
          }

          //setOption(item, type, menuItem, options.option, isValidOption)
          if (isValidOption)
            item[type][menuItem].option = options.option
          else
            item[type][menuItem].option = undefined
      

          
          
          
        } 
      }
      updateOccurenceValue(item, newValue, menuItem, type, isProperty, event, currentIds, options, dependencies, settings, form);
    });
  };

  const getEventToUpdate = (item, event) => { 
    
    const isDefaultEvent = event == globalState.state.formData.actions.event.type.onLoad
    if (!isDefaultEvent)
      if (!item.events) item["events"] = {[event]:{}}
      else if (!item.events[event]) item.events[event] = {}
    
    return isDefaultEvent ? item : item.events[event]
    
  }
/*
  const setPrpopertyValue = (item, type, menuItem, options) => { 
    //item[type.toLowerCase()][menuItem]["option"] = options.option // only for property option
    item[type.toLowerCase()][menuItem].value = options.data 
    
  }
  
  const setOption = (item, type, menuItem, option, isValidOption) => {
    if (isValidOption) {
      if (!item.option) {
        item["option"] = [] 
        item.option.push({type:type.toLowerCase(), menu:menuItem, value:option})
      }
      else {
        var currentOption = item.option.filter(current => current.type == type.toLowerCase() && current.menu == menuItem)[0]
        if (currentOption)
          currentOption.value = option
        else
          item.option.push({type:type.toLowerCase(), menu:menuItem, value:option})
      }
    } else {
      if (item.option)
        item.option = item.option.filter(current => !(current.type == type.toLowerCase() && current.menu == menuItem))
    }
  }
  
  const setConditions = (item, type, menuItem, options, isProperty, event) => { 
    var currentitem = getEventToUpdate (item, event)
    if (!currentitem.conditions) {
      currentitem["conditions"] = [] 
     
      currentitem.conditions.push({isProperty:isProperty,type:type.toLowerCase(), menu:menuItem, values:options.conditions})
    }
    else {
      var currentCondition = currentitem.conditions.filter(current => current.type == type.toLowerCase() && current.menu == menuItem)[0]
      if (currentCondition)
        currentCondition.values = options.conditions
      else
      currentitem.conditions.push({isProperty:isProperty,  type:type.toLowerCase(), menu:menuItem, values:options.conditions})
    }
  }
  
  const setApi = (item, type, menuItem, options, isProperty, event) => { 
    var currentitem =  getEventToUpdate(item, event)
    
    if (!currentitem.api) {
      currentitem["api"] = [] 
      currentitem.api.push({isProperty:isProperty,type:type.toLowerCase(), menu:menuItem, values:options.api})
    }
    else {
      var currentApi = currentitem.api.filter(current => current.type == type.toLowerCase() && current.menu == menuItem)[0]
      if (currentApi)
        currentApi.values = options.api
      else
      currentitem.api.push({isProperty:isProperty,  type:type.toLowerCase(), menu:menuItem, values:options.api})
    }
  }
*/
  const getCurrentItem = (item, type, event) => { 
    var currentitem =   getEventToUpdate(item, event)
    if (!currentitem[type])
      currentitem[type.toLowerCase()] = {}
   
    return currentitem[type]
  }

  const setValue = (item, type, menuItem,newValue, event) => { 
    var currentitem =  getCurrentItem(item, type,  event)
    currentitem[menuItem] = currentitem[menuItem] ? {...currentitem[menuItem],value :newValue}  : {value :newValue}
  }
  /*
  const setProperty = (item, type, menuItem,newValue, event) => { 
    var currentitem =  getCurrentItem(item, type,  event)
    currentitem[menuItem] = currentitem[menuItem] ? {...currentitem[menuItem],value :newValue}  : {value :newValue}
  }

  const setStyle = (item, type, menuItem,newValue, event) => { 
    var currentitem = getCurrentItem(item, type,  event)
    currentitem[menuItem] = newValue
  }
*/
  return changeValue;
};

export default useUpdateOccurenceValue;
